import {
    registerApplication,
    start,
} from "single-spa";
registerApplication(
    "copy",
    () => import("copy_ui"),
    (location) => location.pathname.startsWith("/")
);
start();
